import { createComponent } from '@ycos/fela'
import { getFontStyles } from '../'

const Caption = createComponent(
  'Caption',
  ({ theme, noBottomMargin }) => {
    const {
      typography,
      spacingMultiplier,
      custom: { link, caption }
    } = theme
    const { name, type, ...a } = link

    return {
      ...getFontStyles(typography, { type: 'Label', name: caption.name }),
      direction: 'ltr',
      color: caption.color,
      margin: `0 0 ${noBottomMargin ? 0 : spacingMultiplier}px`,
      padding: '0',
      '> a': a.default,
      '> a:hover': a.hover
    }
  },
  'p'
)

export default Caption
